import { render } from "./SellerItem.vue?vue&type=template&id=16cfc257&scoped=true"
import script from "./SellerItem.vue?vue&type=script&lang=js"
export * from "./SellerItem.vue?vue&type=script&lang=js"

import "./SellerItem.vue?vue&type=style&index=0&id=16cfc257&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16cfc257"]])

export default __exports__